<template>
  <div v-if="dataLoad && opportunite.data">
     <error-msg-component
      :messages="messages"
      :error="error"
      title="Un problème est survenu"
      :withEmplyFields="true"
      :champsVide="champsVide"
      :messagesChampsVide="messagesChampsVide"
      @close="error = $event"/>
    <a ref="lienDownload"></a>
    <div class="is-main-content no-scroll">
      <div class="columns is-fullheight">
        <div class="column">
          <div>
            <div class="container is-fluid">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <a href="javascript:history.back()">
                    <div class="field is-horizontal">
                      <div class="align-center">
                        <b-icon icon="arrow-left" type="is-primary"></b-icon>
                      </div>
                      <div class="field">
                        <p class="is-size-6 has-text-default"
                          style="margin-left:20px;">
                          <strong class="is-size-4">Détail opportunité</strong> <br>
                          {{opportunite.themeCampagne}}
                          <span class="is-size-6" v-if="opportunite.data.devisObject">
                           - Devis n° {{ opportunite.data.devisObject.code}}</span>
                        </p>
                      </div>
                    </div>
                  </a>
                  </div>
                </div>
                <div class="level-rigth ml-0">
                  <div class="buttons ml-40">
                    <b-button
                      icon-left="email"
                      @click="envoyerPdf()">
                      Envoyer
                    </b-button>
                    <b-dropdown aria-role="list">
                      <button
                        class="button mr-5rem"
                        slot="trigger"
                        slot-scope="{ active }"
                        v-if="opportunite.afficherRecap">
                        <b-icon icon="file-download"></b-icon>
                        <span>Récap. réseau</span>
                        <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                      </button>

                      <b-dropdown-item aria-role="listitem" @click="recapitulatif('PDF')">
                        Exporter le récapitulatif PDF
                      </b-dropdown-item>
                      <b-dropdown-item aria-role="listitem" @click="recapitulatif('EXCEL')">
                        Exporter le récapitulatif EXCEL
                      </b-dropdown-item>
                    </b-dropdown>
                    <b-button
                      icon-left="file-pdf"
                      @click="exporterPdf()">
                      PDF
                    </b-button>
                    <b-button
                      icon-left="link-variant"
                      @click="copyLink()"
                      v-if="hasPortailAnnonceur === true && opportunite.permalink != null">
                      Copier le lien
                    </b-button>
                    <b-button
                      icon-left="open-in-new"
                      @click="ouvrirNouvelleFenetre()"
                      v-if="hasPortailAnnonceur === true && opportunite.previewLink != null">
                      Portail
                    </b-button>
                    <b-button
                      @click="copierOpp()">
                      Dupliquer
                    </b-button>
                    <div class="level-item"
                      v-if="opportunite.data && !opportunite.data.valider">
                      <b-button
                        @click="rechargerOpportunite()">
                        Modifier
                      </b-button>
                      <b-tooltip
                        position="is-left"
                        type="is-danger"
                        :active="!!errorValiderDefinitivement.length">
                        <b-button
                          v-if="isAffixe2"
                          type="is-primary"
                          @click="isComponentValiderOpportunite = true"
                          :disabled="!!errorValiderDefinitivement.length">
                          Valider définitivement
                        </b-button>
                        <template v-slot:content>
                          <div class="content m-2">
                            <li
                              v-for="(err, index) in errorValiderDefinitivement"
                              :key="index">
                              {{err}}
                            </li>
                          </div>
                        </template>
                      </b-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="component_panier">
              <div class="section mb-4 level is-marginless">
                <div class="level-left is-align-items-flex-end">
                  <div class="level-item" v-if="!isEmpty(opportunite.data.client)">
                    <app-client
                      :detailOpportunite="opportunite">
                    </app-client>
                  </div>
                  <div class="level-item">
                    <GestionInfoUserOpp
                      is-detail
                      :agenceIdOpp="!isEmpty(opportunite.data.agenceId)
                                    ? opportunite.data.agenceId : ''"/>
                  </div>
                </div>
                <div class="level-right is-align-self-flex-end">
                  <b-tabs type="is-toggle" v-model="tabValue" class="no-tab-content">
                    <b-tab-item label="Produits" class="is-paddingless"
                    icon="format-list-bulleted">
                    </b-tab-item>
                    <b-tab-item label="Cartographie" class="column">
                    </b-tab-item>
                  </b-tabs>
                </div>
              </div>
              <app-produits v-if="dataLoad && tabValue === 0"
                            :produits="opportunite.data.produits"
                            :panier="opportunite"
                            :disabled="disabled"/>
              <app-carte v-if="tabValue === 1" :tabValue="tabValue"
                :produits="opportunite.data.produits"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="isComponentValiderOpportunite">
      <app-valider-definitivement
        @close="isComponentValiderOpportunite = false"
        @valider="validation(opportunite)"/>
    </b-modal>
    <b-modal v-model="isComponentOuvrirEnvoiMail" has-modal-card class="modal" :disabled="true">
      <app-envoi-mail
        :opportunite-id="opportuniteId"
        :opportunite-contact="opportuniteContact"
        :opportunite-client-id="opportuniteClientId"
        :afficher-recap="afficherRecap"
        :permalink="permalink"/>
    </b-modal>
    <b-modal v-model="isComponentConfirmationMail" has-modal-card class="modal">
      <app-confirmation-mail :url="opportunite.url"/>
    </b-modal>
    <b-modal v-model="isComponentCopierOpportunite" has-modal-card class="modal">
      <app-copier-opportunite :opportuniteId="opportuniteId" :type="type"
        @close="isComponentCopierOpportunite = false"/>
    </b-modal>
  </div>
</template>

<script>
import store from '@/store/store';
import { createNamespacedHelpers } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import HTTP from '@/api/HTTP';
import produits from '@/components/creationOpportunite/panier/composantsProduits/produits';
import { putOpportunite } from '@/api/opportunite/index';
import { browseDetailClient } from '@/api/clients/index';
import gestionErreur from '@/services/general/gestionErreur';
import toastConfirmation from '@/services/general/toastConfirmation';
import { SET_IS_MODIF, SET_IS_DUPLICATE } from '@/store/creationOpportunite/panier-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import EnvoiMail from '@/components/creationOpportunite/panier/envoyerOpportunite/envoiMail';
import confirmationMail from '@/components/creationOpportunite/panier/envoyerOpportunite/confirmationMail';
import copierOpportunite from '@/components/mesOpportunites/recherche/copierOpportunite';
import GestionInfoUserOpp from '@/components/creationOpportunite/panier/gestionInfoUserOpp';
import * as devisConf from '@/configuration/devisConf';
import { Brouillon2Enregistre } from '@/api/devis';
import {
  creerDevisOuNon,
  validFacesReseauxTempo,
  updateOppWithDevis,
  addOppPdfToDevis,
  getDataDevisToOpp,
} from '@/services/panier/devis';
import validationDevisCommande from '@/services/devisCommandes/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import estClientBloque from '@/services/client/estClientBloque';
import levelString from '@/services/client/levelToString';
import translator from '@/services/client/translator';
import validationGeneral from '@/services/validation/validation';
import client from './client';
import carte from './carte';
import validerDefinitivement from './validerDefinitivement';

const User = createNamespacedHelpers('user');
const Opportunites = createNamespacedHelpers('opportunites');
const Modal = createNamespacedHelpers('modal');
const Panier = createNamespacedHelpers('panier');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'index',
  data() {
    return {
      disabled: true,
      dataLoad: false,
      isComponentCopierOpportunite: false,
      opportuniteId: null,
      opportuniteContact: null,
      afficherRecap: null,
      permalink: null,
      isComponentValiderOpportunite: false,
      tabValue: 0,
      type: '',
      opportunite: {},
      opportuniteClientId: null,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
    };
  },
  components: {
    appProduits: produits,
    appClient: client,
    appEnvoiMail: EnvoiMail,
    appConfirmationMail: confirmationMail,
    appCopierOpportunite: copierOpportunite,
    appValiderDefinitivement: validerDefinitivement,
    appCarte: carte,
    GestionInfoUserOpp,
    errorMsgComponent,
  },
  computed: {
    ...Opportunites.mapGetters({
      detailOpportunite: 'detailOpportunite',
    }),
    ...User.mapGetters({
      hasPortailAnnonceur: 'hasPortailAnnonceur',
      agences: 'agences',
      agenceId: 'agenceId',
      site: 'site',
    }),
    ...Modal.mapGetters({
      getIsComponentOuvrirEnvoiMail: 'isComponentOuvrirEnvoiMail',
      getIsComponentConfirmationMail: 'isComponentConfirmationMail',
    }),
    ...Panier.mapGetters({
      panier: 'panier',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    isComponentConfirmationMail: {
      get() {
        return this.getIsComponentConfirmationMail;
      },
      set(value) {
        this.setIsComponentConfirmationMail(value);
      },
    },
    isComponentOuvrirEnvoiMail: {
      get() {
        return this.getIsComponentOuvrirEnvoiMail;
      },
      set(value) {
        this.setIsComponentOuvrirMail(value);
      },
    },
    isCreerDevis() {
      if (!this.opportunite.id) return false;
      return creerDevisOuNon(this.opportunite.data.produits);
    },
    messageClientBloque() {
      const clientOpp = this.opportunite.data ? this.opportunite.data.client : null;
      if (!estClientBloque(clientOpp)) return '';
      return `Le client ${clientOpp.nomCommercial} est ${levelString(clientOpp.blocageLevel)}, l'opportunité ne peut pas être validée.`;
    },
    errorValiderDefinitivement() {
      const errors = [];
      if (this.messageClientBloque) errors.push(this.messageClientBloque);
      if (!this.isAffixe2) return errors;
      if (!this.opportunite.data.client.nomCommercial) {
        errors.push('Veuillez indiquer un client ou un prospect');
      }
      if ((this.opportunite.data.produits.panneauxNumeriques.length
          || this.opportunite.data.produits.reseauxNumeriques.length) && store.getters['user/site'] !== 'vildeo' && store.getters['user/site'] !== 'craffichage') {
        if (this.opportunite.data.devisObject) {
          errors.push(`
            L'opportunité est déjà associée au devis ${this.opportunite.data.devisObject.code},
            vous ne pouvez pas ajouter d'écran ou réseaux numériques dans cette opportunité.
          `);
        } else {
          errors.push('La transformation d\'une opportunité en devis n\'est pas possible avec les écrans ou réseaux numériques.');
        }
      }
      return errors;
    },
  },
  methods: {
    ...Opportunites.mapActions({
      actionsRechercheDetailOpportunite: 'rechercheDetailOpportunite',
      actionsGenererDevisOpp: 'genererDevisOpp',
    }),
    ...Modal.mapMutations({
      setIsComponentOuvrirMail: typesModal.SET_IS_COMPONENT_OUVRIR_MAIL,
      setIsComponentConfirmationMail: typesModal.SET_IS_COMPONENT_CONFIRMATION_MAIL,
    }),
    ...Panier.mapActions({
      actionsRechargerOpportunite: 'rechargerOpportunite',
    }),
    ...Panier.mapMutations({
      actionsSetIsModif: SET_IS_MODIF,
      actionsSetIsDuplicate: SET_IS_DUPLICATE,
    }),
    async rechargerOpportunite() {
      if (this.panier.produits.panneauxLc.length ||
        this.panier.produits.reseauxTempo.length ||
        this.panier.produits.reseauxLc.length ||
        this.panier.produits.panneauxNumeriques.length ||
        this.panier.produits.reseauxNumeriques.length ||
        this.panier.produits.reseauxPersonnalise.length) {
        this.opportuniteId = this.opportunite.id;
        this.type = 'modif';
        this.isComponentCopierOpportunite = true;
      } else {
        this.actionsSetIsModif(true);
        const loadingComponent = this.$buefy.loading.open({ container: null });
        await this.actionsRechargerOpportunite(this.opportunite.id);
        loadingComponent.close();
        this.$router.push('/panier');
      }
    },
    copyLink() {
      const domCreate = document.createElement('input');
      document.body.appendChild(domCreate);
      domCreate.setAttribute('value', this.opportunite.permalink);
      domCreate.select();
      try {
        const isCopied = document.execCommand('copy');
        if (isCopied) toastConfirmation('Lien copié');
        else gestionErreur('Problème lors de la copie du lien');
      } catch (e) {
        gestionErreur('Problème lors de la copie  du lien', e);
      }
    },
    ouvrirNouvelleFenetre() {
      window.open(this.opportunite.previewLink);
    },
    recapitulatif(type) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const url = type === 'PDF' ? this.opportunite.urlRecap : this.opportunite.urlRecapExcel;
      HTTP.get(url,
        { responseType: 'blob' },
      ).then((response) => {
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur lors de la generation du recapitulatif PDF de l'opportunite id: ${this.opportunite.id}`, e);
        loadingComponent.close();
      });
    },
    exporterPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      HTTP.get(this.opportunite.url,
        { responseType: 'blob' },
      ).then((response) => {
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur lors de la generation du PDF de l'opportunite id: ${this.opportunite.id}`, e);
        loadingComponent.close();
      });
    },
    envoyerPdf() {
      this.permalink = this.opportunite.permalink;
      this.opportuniteId = this.opportunite.id;
      this.afficherRecap = this.opportunite.afficherRecap;
      this.opportuniteContact = this.opportunite.data.contact;
      this.opportuniteClientId = this.opportunite.annonceurGuid
        ? this.opportunite.annonceurGuid : this.opportunite.annonceurId;
      this.isComponentOuvrirEnvoiMail = true;
    },
    resetMessages() {
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
    },
    async validation(opp) {
      let isNewDevisCommande = false;
      this.resetMessages();
      if (this.messageClientBloque) {
        this.isComponentValiderOpportunite = false;
        gestionErreur(this.messageClientBloque);
        return;
      }
      if (!this.agenceId && this.isAffixe2) {
        this.$buefy.toast.open({
          duration: 5000,
          message: 'Veuillez selectionner une agence',
          position: 'is-bottom',
          type: 'is-danger',
        });
        return;
      }
      if (!validFacesReseauxTempo(opp.data.produits.reseauxTempo)) return;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const produitsReseaux = cloneDeep(opp.data.produits.reseauxTempo);
      try {
        if (opp.data.devisObject && opp.data.devisObject.etat === devisConf.ETAT_BROUILLON) {
          await Brouillon2Enregistre(opp.data.devisObject.id);
          opp.data.valider = true;
          isNewDevisCommande = false;
          await putOpportunite(opp.id, opp);
        } else {
          isNewDevisCommande = true;
          const result = await this.actionsGenererDevisOpp(opp);
          if (result.id) {
            await updateOppWithDevis(result, opp, true);
            await addOppPdfToDevis(false, opp, result.id);
          }
        }
        this.isComponentValiderOpportunite = false;
        this.actionsRechercheDetailOpportunite({ id: opp.id });
      } catch (e) {
        this.isComponentValiderOpportunite = false;
        if (e.response.data.error) {
          this.error = true;
          validationDevisCommande(
            e.response,
            this.messages,
            isNewDevisCommande,
            devisConf.TYPE_DEVIS,
            produitsReseaux);
          validationGeneral(this.$i18n, e.response, this.messages, this.champsVide,
            this.messagesChampsVide, translator);
        }
      } finally {
        loadingComponent.close();
      }
    },
    isEmpty: (el) => isEmpty(el),
    async copierOpp() {
      if (this.panier.produits.panneauxLc.length ||
        this.panier.produits.reseauxTempo.length ||
        this.panier.produits.reseauxLc.length ||
        this.panier.produits.panneauxNumeriques.length ||
        this.panier.produits.reseauxNumeriques.length ||
        this.panier.produits.reseauxPersonnalise.length) {
        this.opportuniteId = this.opportunite.id;
        this.type = 'duplicate';
        this.isComponentCopierOpportunite = true;
      } else {
        this.actionsSetIsDuplicate(true);
        const loadingComponent = this.$buefy.loading.open({ container: null });
        await this.actionsRechargerOpportunite(this.opportunite.id);
        loadingComponent.close();
        this.$router.push('/panier');
      }
      this.opportuniteId = this.opportunite.id;
      this.isComponentCopierOpportunite = true;
    },
    async getDetailOpp() {
      this.dataLoad = false;
      const id = this.$route.params.id;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.actionsRechercheDetailOpportunite({ id: id });
        const opportunite = cloneDeep(this.detailOpportunite);
        opportunite.data.produits.reseauxTempo.forEach(opp => {
          opp.extensionOpportunite.etatObtenu = '';
        });
        this.opportunite = await getDataDevisToOpp(opportunite);
        await this.rafraichirBlocageClient();
        loadingComponent.close();
        this.dataLoad = true;
      } catch (error) {
        loadingComponent.close();
      }
    },
    async rafraichirBlocageClient() {
      const clientOpp = this.opportunite.data ? this.opportunite.data.client : null;
      if (!clientOpp) return;
      const cliNum = this.opportunite.annonceurGuid
        ? this.opportunite.annonceurGuid : this.opportunite.annonceurId;
      if (!cliNum) return;
      try {
        const response = await browseDetailClient(cliNum);
        if (response.data && response.data.blocageLevel) {
          this.$set(clientOpp, 'blocageLevel', response.data.blocageLevel);
        }
      } catch (e) {
        gestionErreur('Impossible de vérifier le niveau de blocage du client', e);
      }
    },
  },
  async mounted() {
    await this.getDetailOpp();
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/detail/index.vue